"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildOptionGroupRenderer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _option_group = _interopRequireDefault(require("./option_group"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var isGroup = function isGroup(option) {
  return option && Array.isArray(option.options);
};
var optionIsSelected = function optionIsSelected(values, option) {
  var removeSelected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!values || values.length === 0) {
    //|| !removeSelected
    return false;
  }
  values = Array.isArray(values) ? values : [values];
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    if (value && value.label === option.label && value.value === option.value) {
      return true;
    }
  }
  return false;
};
var noop = function noop() {};
var buildOptionGroupRenderer = function buildOptionGroupRenderer() {
  var menuRendererConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (props) {
    /*
    This function accepts an object of menuRendererConfig and returns a React
    component. The returned React component has props passed to it by React
    Select.
    This link is made in our `Select` component, where the return value of this
    function call is provided as the 'menuRenderer' prop to `Select`
    The code below (minus the menuRendererConfig wrapper) is heavily based on
    React Select Plus's default renderer.
    These props are the only props passed along by React Select.
    Any other necessary configuration should be passed in menuRendererConfig.
    */
    var focusedOption = props.focusedOption,
      instancePrefix = props.instancePrefix,
      onFocus = props.onFocus,
      onOptionRef = props.onOptionRef,
      onSelect = props.onSelect,
      optionClassName = props.optionClassName,
      optionComponent = props.optionComponent,
      optionRenderer = props.optionRenderer,
      options = props.options,
      valueArray = props.valueArray,
      valueKey = props.valueKey;
    var Option = optionComponent;
    var renderOptions = function renderOptions(optionsSubset) {
      var selectedOptions = menuRendererConfig.selectedOptions,
        allowCategorySelection = menuRendererConfig.allowCategorySelection,
        noResultsText = menuRendererConfig.noResultsText;
      var selectableOptions = optionsSubset.map(function (option, i) {
        if (isGroup(option)) {
          /*
          If group is selected, render nothing
          If group is not selected, render group title and its option children
          */
          var isSelected = optionIsSelected(selectedOptions, option, menuRendererConfig.removeSelected);
          if (allowCategorySelection && isSelected && menuRendererConfig.removeSelected) {
            return null;
          }
          var optionGroupProps = {
            label: optionRenderer(option),
            option: option,
            optionIndex: i,
            onSelect: noop,
            isSelected: false,
            isDisabled: false
          };

          /*
          Devs can enable the selection of categories by passing the
          allowCategorySelection prop to the Select wrapper.
          If this config is enabled and a category is selected, do not
          render its child options.
          */
          if (allowCategorySelection) {
            optionGroupProps.onSelect = onSelect;
            optionGroupProps.isSelected = isSelected;
            optionGroupProps.isDisabled = option.disabled;
          }
          return /*#__PURE__*/React.createElement(_option_group["default"], (0, _extends2["default"])({
            className: "Select-option-group",
            key: "option-group-".concat(i)
          }, optionGroupProps), renderOptions(option.options));
        } else {
          var _isSelected;
          if (valueArray) {
            _isSelected = optionIsSelected(valueArray, option, menuRendererConfig.removeSelected);
          } else if (menuRendererConfig.selectedOptions) {
            _isSelected = optionIsSelected(menuRendererConfig.selectedOptions, option, menuRendererConfig.removeSelected);
          }
          if (_isSelected && menuRendererConfig.removeSelected) {
            return null;
          }
          var isFocused = option === focusedOption;
          var optionClass = (0, _classnames["default"])(optionClassName, 'Select-option', {
            'is-selected': _isSelected,
            'is-focused': isFocused,
            'is-disabled': option.disabled
          });
          return /*#__PURE__*/React.createElement(Option, {
            className: optionClass,
            instancePrefix: instancePrefix,
            isDisabled: option.disabled,
            isFocused: isFocused,
            isSelected: _isSelected,
            key: "option-".concat(i, "-").concat(option[valueKey]),
            onFocus: onFocus,
            onSelect: onSelect,
            option: option,
            optionIndex: i
            // @ts-expect-error - TS7006 - Parameter 'ref' implicitly has an 'any' type.
            ,
            ref: function ref(_ref) {
              onOptionRef(_ref, isFocused);
            }
          }, optionRenderer(option, i));
        }
      });
      selectableOptions = selectableOptions.filter(function (option) {
        return !!option;
      });
      if (!selectableOptions.length) {
        return /*#__PURE__*/React.createElement("div", {
          className: "Select-no-options"
        }, noResultsText);
      }
      return selectableOptions;
    };
    return renderOptions(options);
  };
};
exports.buildOptionGroupRenderer = buildOptionGroupRenderer;